import { render, staticRenderFns } from "./OrganizProfessorList.vue?vue&type=template&id=5b633f6e&scoped=true&"
import script from "./OrganizProfessorList.vue?vue&type=script&scoped=true&lang=js&"
export * from "./OrganizProfessorList.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./OrganizProfessorList.vue?vue&type=style&index=0&id=5b633f6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b633f6e",
  null
  
)

export default component.exports